import { render, staticRenderFns } from "./StatisticsFilters.vue?vue&type=template&id=6829a8cd&"
import script from "./StatisticsFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports